import { Link } from "react-router-dom";
import mute2 from '../simple_mute.svg';
import mute3 from '../simple_unmute.svg';

export default function Header({ auth_checked, authenticated, auth_email, mute, onLogout, onOpenLogin, onToggleMute }) {
  let account_control;
  if (auth_checked){
    account_control = authenticated ? (
      <div id="account_info">
        <Link to="/profile" id="account_email" title={auth_email}>{auth_email}</Link>
        <button id="logout_button" onClick={onLogout}>Log out</button>
      </div>
    ) : (
      <button id="login_button" onClick={onOpenLogin}>
        Log in / Sign up
      </button>
    );
  }
  return (
    <div id="header">
      <div id="button_balancer"></div>
      <h1>Welcome to the Joke Scrambler</h1>
      <div id="header_actions">
        {account_control}
        <button id="mute_button" onClick={onToggleMute} aria-label={mute ? "Unmute" : "Mute"}>
            <img src={mute ? mute2 : mute3} alt=""></img>
            <span className="mute_label" aria-hidden="true">{mute ? "unmute" : "mute"}</span>
        </button>
      </div>
    </div>
  );
}
